const apiUrl = 'https://eventsafeguard-api.azurewebsites.net/api';
//const apiUrl = 'http://localhost:7071/api';

export const USER_TOKEN = () => window.localStorage.getItem('eventsafeguardtoken');

export const USER_LOGIN = () => `${apiUrl}/user-login`;
export const USER_CHANGE_PASSWORD = () => `${apiUrl}/user-change-password`;
export const DASHBOARD_STATISTICS = () => `${apiUrl}/dashboard/statistics`;

export const EVENT_PLACE = () => `${apiUrl}/event-place`;
export const EVENT_PLACE_LOCATION = () => `${apiUrl}/event-place-location`;
export const EVENT_PLACE_LOCATIONS = () => `${apiUrl}/event-place-locations`;
export const EVENT_SUPPLIER = () => `${apiUrl}/event-supplier`;
export const EVENT = () => `${apiUrl}/event`;
export const EVENT_SUPPLIER_PERSONNEL_REQUEST = () => `${apiUrl}/event-supplier-personnel-request`;
export const EVENTS_FOR_SUPPLIER = () => `${apiUrl}/events-for-supplier`;
export const EVENT_PERSONNEL_POOL = () => `${apiUrl}/event-personnel-pool`;
export const EVENT_PERSONNEL_LIST_FOR_CHEF = () => `${apiUrl}/event-personnel-list-for-chef`;
export const EVENT_PERSONNEL = () => `${apiUrl}/event-personnel`;
export const EVENT_PERSONNEL_CHECK = () => `${apiUrl}/event-personnel-check-status`;
export const EVENT_SUPPLIER_PERSONNEL_UPDATE = () => `${apiUrl}/event-supplier-personnel-update`;
export const EVENT_PAYOFF = () => `${apiUrl}/event-payoff`;
export const EVENT_BLACKLIST = () => `${apiUrl}/event-blacklist`;
export const EVENT_PERSONNEL_QUICK_INSERT = () => `${apiUrl}/event-personnel-quick-insert`;
export const EVENT_PERSONNEL_BULK_INSERT = () => `${apiUrl}/event-personnel-bulk-insert`;
export const EVENT_PERSONNEL_SPECIAL_SALARY = () => `${apiUrl}/event-personnel-special-salary`;
 
export const USER_CHANGE_ACCOUNT = () => `${apiUrl}/user-change-account`;
export const PERSONNEL = () => `${apiUrl}/personnel`;
export const PROJECT = () => `${apiUrl}/project`;
export const USER = () => `${apiUrl}/user`;
export const CUSTOMER = () => `${apiUrl}/customer`;
export const FORM = () => `${apiUrl}/form`;


export const DASHBOARD_TASKS = () => `${apiUrl}/dashboard/tasks`;

export const USER_AGENDA = () => `${apiUrl}/user-agenda`;

export const SEARCH_ITEMS = () => `${apiUrl}/utils/search-items`;
export const DOCUMENT_TYPES = () => `${apiUrl}/utils/document-types`;
export const COMPANY_POSITIONS = () => `${apiUrl}/utils/company-positions`;
export const COMPANY_RELATION = () => `${apiUrl}/company-relations`;
export const FILE_UPLOAD = () => `${apiUrl}/utils/file-upload`;
export const FILE_UPLOAD_FOR_JOB_APPLICATION = () => `${apiUrl}/utils/job-application-file-upload`;
export const BANKS = () => `${apiUrl}/utils/banks`;
export const ROLE_LIST = () => `${apiUrl}/utils/role-list`;

export const PERSONNEL_DOCUMENT = () => `${apiUrl}/personnel-document`;
export const PERSONNEL_DOCUMENT_UPLOAD = () => `${apiUrl}/personnel-document/upload`;

export const PERSONNEL_ITEM = () => `${apiUrl}/personnel-item`;

export const PERSONNEL_OGNETNOTIFY = () => `${apiUrl}/personnel-ognetnotify`;

export const PERSONNEL_PROJECT = () => `${apiUrl}/personnel-project`;

export const PERSONNEL_SHORT_LIST = () => `${apiUrl}/personnel-short-list`;

export const PERSONNEL_TIMESHEET = () => `${apiUrl}/personnel-timesheet`;

export const PROJECT_LOCATION = () => `${apiUrl}/project-location`;

export const PROJECT_SHORT_LIST = () => `${apiUrl}/project-short-list`;

export const PROJECT_UPDATE_LOCATION = () => `${apiUrl}/project-update-location`;

export const PROJECT_COMPLETED = () => `${apiUrl}/project-completed`;

export const PROJECT_TIMESHEET = () => `${apiUrl}/project-timesheet`;

export const PROJECT_PARTTIME_TIMESHEET = () => `${apiUrl}/project-part-time-timesheet`;

export const PROJECT_TIMESHEET_NOTE = () => `${apiUrl}/project-timesheet-note`;

export const PROJECT_CONTRACT = () => `${apiUrl}/project-contract`;

export const PROJECT_WORKINGTIME = () => `${apiUrl}/project-workingtime`;

export const PROJECT_ENROLMENT = () => `${apiUrl}/project-case-enrolment`;

export const PROJECT_GOVERNANCE = () => `${apiUrl}/project-governance`;

export const PROJECT_PATROL = () => `${apiUrl}/project-patrol`;

export const PROJECT_FILE = () => `${apiUrl}/project-file`;

export const PERSONNEL_BANK = () => `${apiUrl}/personnel-bank`;

export const PERSONNEL_DAYOFF = () => `${apiUrl}/personnel-dayoff`;

export const PERSONNEL_ENROLMENT = () => `${apiUrl}/personnel-enrolment`;

export const PERSONNEL_PAYROLL = () => `${apiUrl}/personnel-payroll`;

export const JOBAPPLICATION = () => `${apiUrl}/jobapplication`;

export const JOBAPPLICATION_ADD = () => `${apiUrl}/jobapplication-add`;

export const JOBAPPLICATION_NOTE = () => `${apiUrl}/jobapplication-note`;

export const CUSTOMER_OFFER = () => `${apiUrl}/customer-offer`;
export const CUSTOMER_OFFER_SEND = () => `${apiUrl}/customer-offer-send`;
export const CUSTOMER_NOTE = () => `${apiUrl}/customer-note`;

export const COMPANY_TEMPLATE = () => `${apiUrl}/company-template`;

export const REPORT = () => `${apiUrl}/report/`;

export const COMPANY_FILE = () => `${apiUrl}/company-file`;
export const COMPANY_FILE_FOLDER = () => `${apiUrl}/company-file-folder`;
export const COMPANY_FILE_FOLDER_SHARE = () => `${apiUrl}/company-file-folder-share`;

export const SEND_SMS = () => `${apiUrl}/utils/send-sms`;

export const PERSONNEL_DAYOFF_TYPES = () => {
    return [
        { value: 1, label: 'Yillik Ücretli Izin', amount: 1 },
        { value: 2, label: 'Babalık İzni', amount: 0 },
        { value: 3, label: 'Ölüm İzni', amount: 0 },
        { value: 4, label: 'Evlilik İzni', amount: 0 },
        { value: 5, label: 'Yarim Gün Yillik İzin (Ögleden önce)', amount: 0.5 },
        { value: 6, label: 'Yarim Gün Yillik İzin (Ögleden sonra)', amount: 0.5 },
        { value: 7, label: 'Doğum İzni', amount: 0 },
        { value: 8, label: 'İstirahat İzni', amount: 0 },
        { value: 9, label: 'Ücretsiz İzin', amount: 0 },
        { value: 10, label: 'Raporlu', amount: 0 },
        { value: 11, label: 'İş Kazası İzni', amount: 0 }
    ]
}